export enum ManageIntegrationsEnum {
  Envestnet = 'Envestnet',
  Wealthbox = 'Wealthbox',
  Redtail = 'Redtail',
  Salesforce = 'Salesforce',
}